import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

console.log('Google ID:', process.env.REACT_APP_GOOGLE_CLIENT_ID);

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const container = document.getElementById('root');

// react-snap prerenders each route to static HTML at build time. When that
// markup is present, hydrate it (preserves SEO content + avoids a flash);
// otherwise render fresh as usual.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
